import { useTheme } from "@mui/material/styles";
import { SVGProps } from "react";

const HMLogo = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  return <img src="/images/happymango-logo-b.png" />;
};

export default HMLogo;
